<template>
  <div id="cancelSignUp" class="cardPopUp">
    <div class="cardBody cancelCard">
      <h5>Cancel Sign Up?</h5>
      <p>You're a few steps away from great specials & promotions.</p>
      <p>Are you sure you want to cancel?</p>
      <p class="note">Note: All entered info will be cleared</p>
      <div class="actions">
        <button @click="close" class="button is-white">Yes, Cancel</button>
        <button @click="continueSignup" class="button is-blue">Continue Sign Up</button>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "cancelsignup",
  methods: {
    close() {
      document.body.classList.add("transitionBack");
      document.body.classList.remove("cancel");
      this.$store.commit("resetStateProperties");
      this.$router.push("/");

      setTimeout(() => {
        document.body.classList.remove("transitionBack");
      }, 1000);
    },
    continueSignup() {
      document.body.classList.remove("cancel");
    }
  }
};
</script>
